module.exports = (deps = {}) => {
  const windowMock = deps.global || global;
  return () => windowMock.navigator && windowMock.navigator.mediaDevices;
};
